(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairDashboardController', PhysicalFairDashboardController);
    PhysicalFairDashboardController.$inject = ['$filter', '$uibModal', 'ExpoService', 'PhysicalFairService', 'InvoicesService', 'toastr'];
    function PhysicalFairDashboardController($filter, $uibModal, ExpoService, PhysicalFairService, InvoicesService, toastr) {
        var vm = this;
        vm.flag                  = false;
        vm.result                = [];
        vm.expoSelected          = [];
        vm.semesterSelected      = [];
        vm.semester              = [];
        vm.i                     = -1;
        vm.getByFilter           = getByFilter;
        vm.reachedClass          = reachedClass;
        vm.invoicesList          = [];
        vm.getInvoices           = getInvoices;
        vm.loadExpos             = loadExpos;
        vm.expos                 = [];
        vm.expoSelected          = [];


        vm.getStatusLabel = getStatusLabel;
        vm.getStatusClass = getStatusClass;

        vm.getProfileLabel = getProfileLabel;
        vm.getProfileClass = getProfileClass;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        vm.selectExposOptionAll = [
            {
                id: 'active',
                name: '--- Active Expos ---'
            },
            {
                name: '--- All Expos ---'
            },
        ];

        function activate() {
            vm.getByFilter();
            // vm.getInvoices();
            vm.loadExpos();
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};

            let year = moment().format('YYYY');
            let semester = '';
            let quarter = moment().quarter();
            if(quarter == 1 || quarter == 2) {
                semester = '1';
            }
            if(quarter == 3 || quarter == 4) {
                semester = '2';
            }
            semester = `${year}-${semester}`;
            vm.query['semester'] = semester;
            vm.query['goal_type'] = 'report';
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            /* Load variables to CSV */
           var serviceSearch = PhysicalFairService.getByFilterGoalsDashboard(vm.query);
           return  serviceSearch.then(function(response){
               vm.result.goals = response.data;
               if(vm.result.goals.length == 0) {
                   vm.noResultMessage = 'Sorry, no results were found!';
                   vm.flag = false;
               } else {
                   vm.noResultMessage = '';
                   vm.flag = true;
               }
            }).catch(function(err){
            });
        }

        function getInvoices() {
            vm.flag = false;
            vm.query = {};

            vm.query['virtual_fair_id'] = 'active';
            // if (vm.expoSelected) {
            //     vm.query['virtual_fair_id'] = vm.expoSelected.id;
            // }
            
            if(vm.page !== null)
                vm.query['page'] = vm.page;

            vm.query['financial_status'] = 'waiting_invoice';
            let invoice_type = 'virtual_fair';

            /* Load variables to CSV */
            InvoicesService.getByFilter(vm.query, invoice_type).then(function(response) {
                vm.invoicesList = response.data.data; 
                vm.totalItems = response.data.total; 
                vm.to = response.data.to;                              
                vm.itemsPerPage = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }

        function saveGoal(expo_id, seller_id, goal_money, seller) {
           var query =  [];
            if(typeof expo_id !== 'undefined') {
                query['expo_id'] = expo_id;
                if(typeof seller_id !== 'undefined') {
                    query['seller_id'] = seller_id;
                    if(typeof goal_money !== 'undefined') {
                        query['goal_money'] = goal_money;

                        if(typeof vm.query['expo_id'] !== 'undefined') {
                            query['filter_expo_id'] = vm.query['expo_id'];
                        }
                        if(typeof vm.query['semester'] !== 'undefined') {
                            query['filter_semester'] = vm.query['semester'];
                        }
                        PhysicalFairService.saveGoal(query).then(function(response) {
                            if(typeof response.data !== 'undefined') {
                                seller.total = response.data;
                                toastr.success('Successfully edited!');
                            } else {
                                toastr.error('Try again later!', 'Error');
                            }
                        }).catch(function(err) {
                            toastr.danger('Error: '+err);
                        });
                    }
                }
            }
        }

        function loadExpos() {
            ExpoService.getExposVirtualFair().then(function(response){
                vm.expos = vm.selectExposOptionAll.concat(response.data);
                vm.expoSelected = $filter('filter')(vm.expos, {id: 'active'})[0];
            }).catch(function(err) {
            });
        
            
        }

        function getStatusLabel(status) {
            if (status === 'waiting_invoice')
                return 'Invoices not Issued';
            else if (status === 'invoice_created')
                return 'Created but not paid';
            else if (status === 'invoice_paid')
                return 'All invoices paid';
        }

        function getStatusClass(status) {
            if (status === 'waiting_invoice')
                return 'label-danger';
            else if (status === 'invoice_created')
                return 'label-warning';
            else if (status === 'invoice_paid')
                return 'label-success';
        }

        function getProfileLabel(percent) {
            return percent + '% complete';
        }

        function getProfileClass(percent) {
            if (percent >= 75)
                return 'label-success';
            else if (percent >= 50)
                return 'label-warning';
            else
                return 'label-danger';
        }

        function reachedClass(goal_money, invoice_total) {
            if(goal_money <= invoice_total) {
                return 'label-success';
            } else if(goal_money * 0.7 <= invoice_total && goal_money > invoice_total) {
                return 'label-warning';
            } else {
                return 'label-danger';
            }
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        activate();
    }
})();